<template>
  <BContainer class="mt-5 mb-5">
    <BRow>
      <BCol md="5" offset-md="1">
        <Panel class="mb-3">
          <h2>{{ t('Sign in') }}</h2>
          <LoginForm :redirect-success="localePath('/vip/')" />
        </Panel>
        <Panel class="mb-3">
          <p>{{ t('Contacts for Cosmoscow VIP guests support') }}</p>
          <BButton variant="outline-dark" block :to="localePath('/vip/contacts/')">
            <Icon name="fa6-regular:comments" />
            {{ t('Contact support') }}
          </BButton>
        </Panel>
      </BCol>
      <BCol md="5">
        <Panel>
          <h2>{{ t('Registration with invitation code') }}</h2>
          <p>
            {{
              t(
                'If you have an invitation to activate a VIP card, please enter the invitation code below',
              )
            }}.
          </p>
          <InvitationCodeActivation redirect-to-reg redirect-to-reg-path="/vip/registration/" />
        </Panel>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script setup lang="ts">
import { definePageMeta, useHead, useLocalePath } from '#imports'
import { useI18n } from 'vue-i18n'
import LoginForm from '~/components/auth/LoginForm.vue'
import InvitationCodeActivation from '~/components/invitation_code/InvitationCodeActivation.vue'
import Panel from '~/components/global/Panel.vue'

const { t } = useI18n()
const localePath = useLocalePath()

useHead(() => ({
  title: t('Cosmoscow VIP area'),
}))

definePageMeta({
  layout: 'vip',
  auth: 'guest',
})
</script>

<i18n lang="json">
{
  "en": {
    "Sign in": "Sign in",
    "Registration with invitation code": "Registration with invitation code",
    "If you have an invitation to activate a VIP card, please enter the invitation code below": "If you have an invitation to activate a VIP card, please enter the invitation code below",
    "Contact support": "Contact support",
    "Contacts for Cosmoscow VIP guests support": "Contacts for Cosmoscow VIP guests support",
    "Cosmoscow VIP area": "Cosmoscow VIP area"
  },
  "ru": {
    "Sign in": "Войти",
    "Registration with invitation code": "Регистрация по коду приглашения",
    "If you have an invitation to activate a VIP card, please enter the invitation code below": "Если у вас есть Пригласительный для активации VIP-карты, пожалуйста, введите ниже код приглашения",
    "Contact support": "Написать в поддержку",
    "Contacts for Cosmoscow VIP guests support": "Контакты для поддержки VIP-клиентов Cosmoscow",
    "Cosmoscow VIP area": "VIP-раздел Cosmoscow"
  }
}
</i18n>
